import { useMutation } from "@tanstack/react-query";
import { Product, ProductFormValues } from "../../types";
import { createProductService } from "../realService";

export function useCreateProductMutation(options?: {
  onSuccess?: (data: Product) => void;
  onError?: (error: any) => void;
}) {
  return useMutation({
    mutationFn: (data: ProductFormValues) => createProductService(data),
    ...options,
  });
}
